import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Lato', sans-serif; /* Substitua 'SuaFonte' pelo nome da sua fonte */
  }
`;

export default GlobalStyle;
